import React, { ReactNode, ReactElement, SFC, useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import CalendarDetail from "../Detail";
import { connect } from "dvajs";
import "./index.less";
import { useTranslation } from "react-i18next";
import { ScheduleDetailFrom } from "@/components/Calendars/Schedule/Detail";

/**
 *  用来渲染日程item
 *
 * @export
 * @returns
 */
interface IProps {
  item: any;
  ItemRender?: (props: any) => ReactElement;
  DetailRender?: (props: any) => ReactElement;
  selectedScheduleTime?: Dayjs;
  children: any;
  otherUser: any;
  disable?: boolean;
  close?: Function;
  changeScheduleInfoDraw: (payload: {
    visible: boolean;
    scheduleId: string;
    selectedScheduleTime: Dayjs;
    from: number;
    openTime: Dayjs;
    isBusy: number;
    busyRealName: string;
    beginTime: Dayjs;
    endTime: Dayjs;
  }) => void;
}
const SchedulePopover: SFC<IProps> = ({
  item,
  selectedScheduleTime,
  DetailRender = CalendarDetail,
  children,
  otherUser,
  disable,
  close,
  changeScheduleInfoDraw
}) => {
  const { t } = useTranslation("calendar");
  function onVisibleChange() {
    // 权限管理
    if (disable) {
      return;
    }
    // if (otherUser) {
    //   // 表示查看别人的日程，需要做权限管理
    //   let calendar = calendarMap[item.calendarId];
    //   if (calendar && calendar.scope !== Scope.Public) {
    //     return;
    //   }
    // }

    changeScheduleInfoDraw({
      visible: true,
      scheduleId: item.scheduleId,
      selectedScheduleTime: selectedScheduleTime || dayjs(), // 选中的时间
      from: ScheduleDetailFrom.Calendar,
      openTime: dayjs(),
      isBusy: item.isBusy,
      busyRealName: item.realName,
      beginTime: item.scheduleBeginTime,
      endTime: item.scheduleEndTime
    });
  }
  return <span onClick={onVisibleChange}>{children} </span>;
};
function mapStateToProps({ calendar }: any) {
  return {
    otherUser: calendar.otherUser
  };
}
function mapDispatchToProps(dispatch: any) {
  return {
    changeScheduleInfoDraw: (payload: {
      visible: boolean;
      scheduleId: string;
      selectedScheduleTime: Dayjs;
      from: number;
      openTime: Dayjs;
      isBusy: number;
      busyRealName: string;
      beginTime: Dayjs;
      endTime: Dayjs;
    }) =>
      dispatch({
        type: "calendar/changeScheduleInfoDraw",
        payload
      })
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SchedulePopover);
